'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);

var _iconPdf = require('../../../../static/icons/icon-pdf.png');var _iconPdf2 = _interopRequireDefault(_iconPdf);

var _UploadAssetWidget = require('../UploadAssetWidget.scss');var styles = _interopRequireWildcard(_UploadAssetWidget);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var ImageWrapper = function ImageWrapper(properties) {return (
    _react2.default.createElement('div', { className: styles.imageWrapper },
      _react2.default.createElement('div', {
          id: 'rotated_image_' + properties.id,
          className: (0, _classnames2.default)(styles.images, 'upload-img'),
          style: {
            transform: 'rotate(' + properties.angle + 'deg)' } },


        _react2.default.createElement('img', {
          src: properties.isRaw ? _iconPdf2.default : properties.image,
          alt: '',
          style: {
            backgroundImage: 'url(' + properties.image + ')' } })),




      properties.uploadInProgress &&
      _react2.default.createElement('div', { className: styles.uploadProgress },
        _react2.default.createElement('div', { id: 'uploadProgressBar_' + properties.id })),



      properties.isVideo && _react2.default.createElement('i', { className: 'icon icon-widget-video' })));};exports.default =



ImageWrapper;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/UploadAssetWidget/HelpComponents/ImageWrapper.js
// module id = 1238
// module chunks = 0